module.exports = __webpack_public_path__ + "static/media/qbv.15e9af9b.png";